<template>
  <div class="container">
    <breadcrumb></breadcrumb>
    <div class="select-box input_left">
      <Input v-model="searchPluginTitle" style="width:100px;" placeholder="插件名称"/>
    </div>
    <div class="select-box input_left_two">
      <Input v-model="searchPluginCode" style="width:100px;" placeholder="插件包名" />
      <Input v-model="searchPkgName" style="width:100px;margin-left:25px;" placeholder="宿主包名" />
      <!-- pkgName -->
      <Select v-model="searchEnableStatus" style="width: 100px;margin-left:25px;" placeholder="插件状态">
        <Option :value="0">禁用</Option>
        <Option :value="1">启用</Option>
      </Select>
      <!-- <Select v-model="searchStatus" style="width: 100px;margin-left:25px;" placeholder="审核状态">
        <Option :value="0">待审核</Option>
        <Option :value="1">审核通过</Option>
        <Option :value="2">审核驳回</Option>
      </Select> -->
    </div>
    <div class="select-box input_left_four">
      <Button type="primary" @click="newAlert" style="margin-right:5px;">上传SDK插件</Button>
    </div>
    <div class="select-box input_left_three">
      <Button type="primary" @click="searchBtn" style="margin-right:5px;">查询</Button>
      <Button type="primary" @click="searchClear">重置</Button>
    </div>
    <!-- <div class="select-box">
    </div> -->
    <div class="app-list-table">
      <Table :loading="tableLoading" ref="selection" @on-selection-change="tableOnSelect" class="spacingTwice" border :columns="columns" :data="dataList"></Table>
      <Page show-total :total="total" :current="current" :page-size="pageSize"
          @on-change="pageChange" @on-page-size-change="pageSizeChange" show-sizer />
    </div>
    <Modal
      width="600"
      :mask-closable="false"
      v-model="newdata"
      :footer-hide="editFlag === 'true'?true:false"
      :title="editId ? editFlag === 'true' ? '查看':'编辑' : '上传SDK插件'"
      :loading="loading"
      @on-cancel="closeModal"
      @on-ok="editData('formValidate')">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">
        <FormItem label="指定渠道" prop="channelCode">
          <Select
                :disabled="editId?true:channelCodeFlag"
                v-model="formValidate.channelCode"
                placeholder="请选择指定渠道，保存后不可修改"
                filterable
                >
                <Option v-for="(option, index) in channelList" :value="option.code" :tag="option.name" :key="index">{{option.code}}</Option>
            </Select>
        </FormItem>
        <FormItem label="文件上传" v-show="editId?false:formValidate.channelCode"  prop="apkPath">
          <Upload type="file" accept='.zip' ref="upload" :headers="{'token':token}" :before-upload="brforeUpload" :onProgress="fileProgress" :onSuccess="filesuccess" :action="`${baseUrl}/extscreenapi/plugin/hili/esAppPluginTest/uploadZipFile?channelCode=${formValidate.channelCode === 'all'?'':formValidate.channelCode}`">
              <Button icon="ios-cloud-upload-outline" :disabled="editId?true:false">上传</Button>
          </Upload>
          <p>{{fileName}}</p>
          <Progress :percent="filePercent" v-show="filePercent > 0" :stroke-width="2" />
          <div style="font-size:12px;">文件格式为zip</div>
        </FormItem>
        <FormItem label="插件名称" prop="pluginTitle">
          <Input v-model="formValidate.pluginTitle" :disabled="editFlag === 'true'" placeholder="请输入插件名称" />
        </FormItem>
        <FormItem label="占用大小" prop="useSpace" v-show="editId?false:true">
          <Input v-model="formValidate.useSpace" :disabled="editId?true:false" placeholder="插件解压后的大小，单位MB，如不填写默认100MB" >
          <template #append>
              <span>MB</span>
            </template>
          </Input>
        </FormItem>
        <FormItem label="插件状态" v-show="editId?true:false" prop="enableStatus">
          <RadioGroup v-model="formValidate.enableStatus">
            <Radio :disabled="editFlag === 'true'" label="启用"></Radio>
            <Radio :disabled="editFlag === 'true'" label="禁用"></Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="更新说明" prop="remarks">
          <Input v-model="formValidate.remarks" :disabled="editFlag === 'true'" placeholder="备注最大字数为50字" maxlength="50" type="textarea" :rows="4" />
        </FormItem>
        <FormItem label="插件包名" prop="pluginCode">
          <Input v-model="formValidate.pluginCode" :disabled="true" placeholder="上传插件后自动生成" />
        </FormItem>
        <FormItem label="宿主包名" prop="pkgName">
          <Input v-model="formValidate.pkgName" :disabled="true" placeholder="上传插件后自动生成" />
        </FormItem>
        <FormItem label="版本名称" prop="pluginVerName" v-show="editId?false:true">
          <Input v-model="formValidate.pluginVerName" :disabled="true" placeholder="上传插件后自动生成" />
        </FormItem>
        <FormItem label="版本号" prop="pluginVerCode" v-show="editId?false:true">
          <Input v-model="formValidate.pluginVerCode" :disabled="true" placeholder="上传插件后自动生成" />
        </FormItem>
        <FormItem label="校验值" prop="md5" v-show="editId?false:true">
          <Input v-model="formValidate.md5" :disabled="true" placeholder="上传插件后自动生成" />
        </FormItem>
        <FormItem label="UUID" prop="uuid" v-show="editId?false:true">
          <Input v-model="formValidate.uuid" :disabled="true" placeholder="上传插件后自动生成" />
        </FormItem>
        <FormItem label="资源ID" prop="resourceId" v-show="editId?false:true">
          <Input v-model="formValidate.resourceId" :disabled="true" placeholder="上传插件后自动生成" />
        </FormItem>
      </Form>
    </Modal>
    <verify-modal ref="verify"></verify-modal>
  </div>
</template>

<script>
import breadcrumb from '@/components/global/breadcrumb'
import verifyModal from '@/components/global/verifyModal'
import https from '../../https'
import Axios from 'axios'
export default {
  name: 'esApp',
  data () {
    return {
      loading: true,
      tableLoading: true,
      newdata: false,
      authorized: false,
      mobileApp: [],
      editId: '',
      editItem: '',
      userList: [],
      userInfoId: '',
      searchPluginTitle: '',
      searchPluginCode: '',
      searchPkgName: '',
      searchEnableStatus: '',
      currentIndex: '',
      isShowSpin: false,
      tableSelectRow: [],
      baseUrl: '',
      editFlag: 'false',
      formValidatePl: {
        ver: ''
      },
      formValidate: {
        pluginTitle: '',
        pluginCode: '',
        channelCode: '',
        pkgName: '',
        // storeVerCodes: '',
        remark: '',
        pluginVerName: '',
        pluginVerCode: '',
        md5: '',
        uuid: '',
        resourceId: '',
        id: '',
        apkId: '',
        enableStatus: '启用',
        apkPath: ''
      },
      ruleValidate: {
        pluginTitle: [{ required: true, message: '请输入插件名称' }],
        channelCode: [{ required: true, message: '请选择指定渠道' }],
        // enableStatus: [{ required: true, message: '请选择启用状态' }]
        apkPath: [{ required: true, message: '文件格式为zip' }]
      },
      columns: [ // table表格
        {
          title: '用户名',
          key: 'userName',
          width: 200,
          align: 'center'
        },
        {
          title: '插件名称',
          key: 'pluginTitle',
          width: 200,
          align: 'center'
        },
        {
          title: '插件包名',
          key: 'pluginCode',
          width: 150,
          align: 'center'
        },
        {
          title: '宿主包名',
          key: 'pkgName',
          align: 'center',
          width: 150
        },
        {
          title: '指定渠道',
          key: 'channelCode',
          align: 'center',
          width: 100,
          render: (h, params) => {
            let status = ''
            if (params.row.channelCode.length > 0) {
              status = params.row.channelCode
            } else {
              status = '全部'
            }
            let html = [
              h('span', status)
            ]
            return html
          }
        },
        {
          title: '插件状态',
          key: 'enableStatus',
          align: 'center',
          width: 100,
          render: (h, params) => {
            let status = ''
            switch (params.row.enableStatus) {
              case 0:
                status = '禁用'
                break
              case 1:
                status = '启用'
                break
            }
            let html = [
              h('span', status)
            ]
            return html
          }
        },
        {
          title: '更新说明',
          key: 'remarks',
          align: 'center',
          width: 250
        },
        {
          title: '创建时间',
          key: 'createTime',
          align: 'center',
          minWidth: 250
        },
        {
          title: '最后更新时间',
          key: 'updateTime',
          align: 'center',
          minWidth: 250,
          render: (h, params) => {
            let status = ''
            if (params.row.updateTime != null) {
              status = params.row.updateTime
            } else {
              status = params.row.createTime
            }
            let html = [
              h('span', status)
            ]
            return html
          }
        },
        {
          title: '操作',
          width: 220,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  width: '50px',
                  marginRight: '10px'
                },
                on: {
                  click: () => {
                    this.newAlert(params.index)
                  }
                }
              }, params.row.createBy === this.userId ? '编辑' : '查看'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  width: '70px',
                  marginRight: '10px'
                },
                on: {
                  click: () => {
                    this.$router.push({
                      path: `/developer/versionSdkTest`,
                      query: {
                        pluginTitle: params.row.pluginTitle,
                        id: params.row.id,
                        status: params.row.status
                      }
                    })
                  }
                }
              }, '版本管理')
            ])
          }
        }
      ],
      mobileData: {
        id: '',
        name: '',
        app_rel: []
      },
      channelList: [],
      appPkgFlag: false,
      dataSource: [], // table数据源
      tvpList: [],
      dataList: [], // tab当前页数据
      total: 0, // tab总条数
      pageSize: 10, // 每页多少条
      current: 1, // 当前页
      t1: 0,
      t2: 0,
      timer: null,
      userId: '',
      channelCodeFlag: false,
      token: null,
      isNew: false,
      fileformat: ['zip'],
      fileName: null,
      filePercent: 0,
      uploadModal: false,
      errorModal: false,
      cancelUpload: {
        cancel: null
      }
    }
  },
  components: {
    breadcrumb,
    verifyModal
  },
  created () {
    if (!https.token) {
      this.$router.push('/')
      return
    }
    this.token = https.token
    this.baseUrl = process.env.API_HOST
    this.userId = localStorage.getItem('userId')
    this.loadData()
  },
  mounted () {
  },
  methods: {
    brforeUpload (file) {
      console.log(file)
      this.fileAjaxUpload(file)
      return false
      // let main = this.$refs.upload
      // if (main.fileList && main.fileList.length) {
      //   main.fileList.forEach(item => {
      //     main.clearFiles()
      //   })
      // }
    },
    fileAjaxUpload (file) {
      let that = this
      this.fileName = file.name
      let index1 = file.name.lastIndexOf('.')
      let index2 = file.name.length
      let fileSuffix = file.name.substring(index1 + 1, index2).toLowerCase()
      if (this.fileformat.indexOf(fileSuffix) === -1) {
        this.$Message.error('文件格式不正确,请上传zip格式文件')
        return false
      }
      let fd = new FormData()
      fd.append('file', file)
      const CancelToken = Axios.CancelToken
      https.requestUpload({
        url: this.baseUrl + '/extscreenapi/plugin/hili/esAppPluginTest/uploadZipFile?channelCode=' + (this.formValidate.channelCode === 'all' ? '' : this.formValidate.channelCode),
        method: 'post',
        data: fd,
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        cancelToken: new CancelToken(function executor (c) {
          that.cancelUpload.cancel = c
        }),
        onUploadProgress: (progressEvent) => { // 上传进度事件
          console.log(progressEvent)
          if (progressEvent) {
            that.filePercent = Number((progressEvent.loaded / progressEvent.total * 100).toFixed(2))
          }
        }
      }).then(res => {
        console.log('成功')
        this.filesuccess(res)
      }).catch(error => {
        this.filePercent = 0
        this.fileName = ''
        console.log('失败', error)
      })
    },
    fileProgress () {
      this.formValidate.pluginTitle = ''
      this.formValidate.pluginCode = ''
      this.formValidate.pkgName = ''
      this.formValidate.pluginVerName = ''
      this.formValidate.pluginVerCode = ''
      this.formValidate.md5 = ''
      this.formValidate.uuid = ''
      this.formValidate.resourceId = ''
      this.formValidate.id = ''
      this.formValidate.apkId = ''
      this.formValidate.apkPath = ''
    },
    filesuccess (e) {
      console.log(e)
      if (e.code === 500) {
        this.$Message.error('上传zip包失败，请重新上传')
      } else if (e.code === 400) {
        this.$Message.error(e.message)
        this.formValidate.pluginTitle = ''
        this.formValidate.pluginCode = ''
        this.formValidate.pkgName = ''
        this.formValidate.pluginVerName = ''
        this.formValidate.pluginVerCode = ''
        this.formValidate.md5 = ''
        this.formValidate.uuid = ''
        this.formValidate.resourceId = ''
        this.formValidate.id = ''
        this.formValidate.apkId = ''
        this.formValidate.apkPath = ''
        this.fileName = ''
        this.channelCodeFlag = false
        this.brforeUpload()
      } else {
        this.formValidate.pluginTitle = e.result.pluginTitle
        this.formValidate.pluginCode = e.result.pluginCode
        this.formValidate.pkgName = e.result.pkgName
        this.formValidate.id = e.result.id
        this.formValidate.apkId = e.result.apkId
        this.formValidate.pluginVerName = e.result.pluginVerName
        this.formValidate.pluginVerCode = e.result.pluginVerCode
        this.formValidate.md5 = e.result.md5
        this.formValidate.uuid = e.result.uuid
        this.formValidate.resourceId = e.result.resourceId
        this.formValidate.apkPath = e.result.apkPath
        this.channelCodeFlag = true
        this.isNew = e.result.new
      }
    },
    closeModal () {
      this.channelCodeFlag = false
      this.fileName = ''
      if (this.cancelUpload.cancel) {
        this.filePercent = 0
        this.cancelUpload.cancel()
      }
      this.$refs['formValidate'].resetFields()
    },
    getChannels () {
      https.request({
        method: 'get',
        url: '/v2/es/channels',
        params: {
          page_size: 100
        }
      }).then(res => {
        let first = {
          name: '全部',
          code: 'all'
        }
        this.channelList = res.data.items || []
        this.channelList.unshift(first)
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    tableOnSelect (row) {
      this.tableSelectRow = row
    },
    pageSizeChange (size) {
      this.pageSize = size
      this.current = 1
      this.loadData()
    },
    // 页数切换
    pageChange (page) {
      this.current = page
      this.loadData()
    },
    searchBtn () {
      this.loadData()
    },
    searchClear () {
      this.searchPluginTitle = ''
      this.searchPluginCode = ''
      this.searchPkgName = ''
      this.searchEnableStatus = ''
      this.loadData()
    },
    aduitText (val) {
      if (val === 0) {
        return '未提审'
      } else if (val === 1) {
        return '待审核'
      } else if (val === 2) {
        return '审核通过'
      } else if (val === 3) {
        return '审核驳回'
      }
    },
    changeUserId (val) {
      this.searchPluginTitle = ''
      this.searchPluginCode = ''
      this.searchPkgName = ''
      this.searchEnableStatus = ''
      this.loadData(val)
      console.log('测试')
    },
    clearUserId () {
      this.loadData()
    },
    getUserNameAuth () {
      let userNameAuth = sessionStorage.getItem('user_name_auth')
      if (userNameAuth !== null) {
        this.userList.map(item => {
          if (item.label === userNameAuth) {
            this.userInfoId = item.value
            this.loadData(item.value)
            sessionStorage.removeItem('user_name_auth')
          }
        })
      }
    },
    // 加载tabs列表
    loadData (id = '') {
      let params = {
        column: 'updateTime',
        order: 'desc',
        pageSize: this.pageSize,
        pageNo: this.current,
        pluginTitle: `*${this.searchPluginTitle}*`,
        pluginCode: this.searchPluginCode,
        pkgName: `*${this.searchPkgName}*`,
        // uuid: `*${this.searchUuid}*`,
        enableStatus: this.searchEnableStatus
      }
      this.isShowSpin = true
      https.request({
        method: 'get',
        url: 'extscreenapi/plugin/hili/esAppPluginTest/list',
        params: params
      }).then(res => {
        console.log(res)
        this.tableLoading = false
        this.isShowSpin = false
        // this.dataList = res.result.records
        this.getUserNameFun(res.result.records)
        this.total = res.result.total
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    getUserNameFun (list) {
      let arr = []
      list.map(item => {
        arr.push(item.createBy)
      })
      let str = arr.join(',')
      https.request({
        method: 'get',
        url: `getUsernamesByIds?ids=${str}`,
        params: {}
      }).then(res => {
        res.data.map(item => {
          list.map(sItem => {
            if (item.value === sItem.createBy) {
              sItem['userName'] = item.text
            }
          })
        })
        this.dataList = list
      })
    },
    newAlert (index) {
      this.$refs['formValidate'].resetFields()
      this.getChannels()
      if (!isNaN(index)) {
        this.formValidate = {
          // storeVerCodes: this.dataList[index].storeVerCodes,
          useSpace: this.dataList[index].useSpace ? this.dataList[index].useSpace / 1024 / 1024 : '',
          enableStatus: this.dataList[index].enableStatus === 1 ? '启用' : '禁用',
          remarks: this.dataList[index].remarks,
          channelCode: this.dataList[index].channelCode.length === 0 ? 'all' : this.dataList[index].channelCode,
          pluginTitle: this.dataList[index].pluginTitle,
          pluginCode: this.dataList[index].pluginCode,
          pkgName: this.dataList[index].pkgName,
          pluginVerName: this.dataList[index].pluginVerName,
          pluginVerCode: this.dataList[index].pluginVerCode,
          md5: this.dataList[index].md5,
          uuid: this.dataList[index].uuid,
          resourceId: this.dataList[index].resourceId,
          id: this.dataList[index].id,
          apkId: this.dataList[index].apkId,
          apkPath: '00'
        }
        this.editId = this.dataList[index].id
        this.editFlag = this.dataList[index].createBy === this.userId ? 'false' : 'true'
        // this.editItem = this.dataList[index]
        this.currentIndex = index
      } else {
        this.formValidate.useSpace = ''
        this.editId = ''
      }
      this.newdata = true
    },
    editData (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          setTimeout(() => {
            this.changeLoading()
            if (this.formValidate.apkPath.length === 0) {
              this.$Message.error('请上传sdk插件')
              return
            }
            let params = {
              // storeVerCodes: this.formValidate.storeVerCodes,
              enableStatus: this.formValidate.enableStatus === '启用' ? 1 : 0,
              useSpace: this.formValidate.useSpace === '' || this.formValidate.useSpace === null ? '104857600' : this.formValidate.useSpace * 1024 * 1024,
              remarks: this.formValidate.remarks,
              pluginTitle: this.formValidate.pluginTitle,
              id: this.formValidate.id,
              apkId: this.formValidate.apkId
            }
            if (this.editId) {
              params['id'] = this.editId
              https.request({
                method: 'put',
                url: 'extscreenapi/plugin/hili/esAppPluginTest/edit',
                data: params
              }).then(res => {
                console.log(res)
                if (res.code === 400) {
                  console.log(res.message)
                  this.$Message.error(res.message)
                  this.newdata = false
                  this.loadData()
                  return
                }
                if (res.code === 500) {
                  this.$Message.error(res.message)
                  return
                }
                this.$Message.success('提交成功')
                this.newdata = false
                this.loadData()
              }).catch(error => {
                this.$Message.error(error)
              })
            } else {
              this.channelCodeFlag = false
              if (this.isNew) {
                this.$Modal.confirm({
                  title: '温馨提示',
                  content: '<p class="del-modal-txt">检测到没有该包名的插件，是否要创建该插件？</p>',
                  onOk: () => {
                    https.request({
                      method: 'put',
                      url: 'extscreenapi/plugin/hili/esAppPluginTest/editUpload',
                      data: params
                    }).then(res => {
                      if (res.code === 500) {
                        this.$Message.error(res.message)
                        return
                      } else if (res.code === 400) {
                        this.$Message.error(res.message)
                        return
                      }
                      this.$Message.success('提交成功')
                      this.newdata = false
                      this.loadData()
                    }).catch(error => {
                      this.$Message.error(error)
                    })
                  }
                })
              } else {
                https.request({
                  method: 'put',
                  url: 'extscreenapi/plugin/hili/esAppPluginTest/editUpload',
                  data: params
                  // headers: {
                  //   'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                  // }
                }).then(res => {
                  console.log(res)
                  if (res.code === 500) {
                    this.$Message.error(res.message)
                    return
                  } else if (res.code === 400) {
                    this.$Message.error(res.message)
                    return
                  }
                  this.$Message.success('提交成功')
                  this.newdata = false
                  this.loadData()
                }).catch(error => {
                  this.$Message.error(error)
                })
              }
            }
          }, 1000)
        } else {
          this.changeLoading()
        }
      })
    },
    changeLoading () {
      this.loading = false
      this.$nextTick(() => {
        this.loading = true
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .container{
    position: relative;
  }
  .file-wrap {
    position: relative;
    display: inline-block;
    margin-bottom: 10px;
    .file-input {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
  .env-btn {
    display: flex;
    justify-content: space-between;
    button {
      width: 140px;
    }
  }
  .select-box{
    display: flex;
    position: absolute;
    top: 20px;
    right: 140px;
    .select-label{
      line-height: 32px;
      margin-right: 10px;
    }
  }
  .select-box-type{
    display: flex;
    position: absolute;
    top: 20px;
    right: 60px;
  }
  .select-box-type-pl{
    display: flex;
    position: absolute;
    top: 20px;
    right: 260px;
  }
  .input_left{
    left:140px;
    // left:407px;
  }
  .input_left_two{
    left:263px;
    // left:580px;
  }
  .input_left_three{
    // left:666px;
    left:753px;
  }
  .input_left_four{
    left:139px;
    top:60px;
  }
  .app_aduit_stats{
    position: absolute;
    top:0px;
    right:0px;
  }
  .app_close_stats{
    position: absolute;
    top:0px;
    left:4px;
  }
  .app-list-table{
    padding:53px 0;
  }
  .agreement_title{
    text-align: center;
    font-size:20px;
    font-weight: bold;
  }
  .agreement_text{
    width:700px;
    // border:1px solid #000;
    height:500px;
    overflow-y: auto;
    margin-left:50px;
  }
  #copyinput{
    position: absolute;
    bottom: -30px;
  }
  .card-spin-container{
        display: inline-block;
        width: 100%;
        height: 100%;
        // position: relative;
    }
</style>



// WEBPACK FOOTER //
// src/components/esSdkTest/esSdkTest.vue